<template>
  <div class="mt-10">
    <template v-for="rowIndex in 2">
      <v-row
        :key="rowIndex"
      >
        <template v-for="weekCount in 2">
          <v-col :key="weekCount">
            <section>
              <line-chart
                :raw-data="dailyTeamStats.data.slice(28 - (weekCount + (rowIndex - 1) * 2) * 7, 28 - (weekCount + (rowIndex - 1) * 2 - 1) * 7)"
                :chart-value-keys="[ { key: 'DL', type: 'bar', label: $t('table_headers.weekly_load.avg_daily_load') }, { key: 'TG', label: $t('table_headers.weekly_load.avg_rpe') } ]"
                x-value="date"
                y-value-prefix="stats."
                :yaxis="[ { title: { text: $t('table_headers.weekly_load.avg_daily_load') }}, { title: { text: $t('table_headers.weekly_load.avg_rpe') }, opposite: true } ]"
                :colors="[ '#c42b59', '#ad6843' ]"
              >
                <template v-slot:header>
                  <v-card-title class="pa-6">
                    <div class="subtitle-2 grey--text text--grey-100">
                      {{ $t("card_title.week") }} -{{ weekCount + (rowIndex - 1) * 2 }}
                    </div>
                  </v-card-title>
                </template>
              </line-chart>
            </section>
          </v-col>
        </template>
      </v-row>
    </template>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
    name: 'TrainingLoadWeeklyGraphs',
    components: { LineChart },
    props: {
      dailyTeamStats: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        default: 'total'
      }
    }
}

</script>
